import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { FlexBox } from '../box';
import { styled } from '../styled';
import { getPaletteColor } from '../theme';
import { Typography } from '../typography';
import { makeEnum, withVersion } from '../utils';
export const PasswordStrength = makeEnum('WEAK', 'MEDIUM', 'STRONG');
const SEGMENTS = 3;
const STRENGTH_VALUE = {
    WEAK: 1,
    MEDIUM: 2,
    STRONG: 3
};
const STRENGTH_COLOR = {
    WEAK: 'error.main',
    MEDIUM: 'warning.main',
    STRONG: 'success.main'
};
const INACTIVE_COLOR = 'action.disabled-background';
const Root = styled(FlexBox)({
    width: 200
});
const Segment = styled('span')(({ theme, $active, $color }) => ({
    flex: 1,
    height: theme.spacing(0.5),
    borderRadius: theme.spacing(0.25),
    backgroundColor: $active
        ? getPaletteColor(theme, $color)
        : getPaletteColor(theme, INACTIVE_COLOR)
}));
const IssueList = styled(FlexBox)(({ theme }) => ({
    margin: 0,
    paddingLeft: theme.spacing(2)
}));
const PasswordStrengthIndicatorImpl = React.forwardRef((props, ref) => {
    const { strength, issues, strengthLabel, className, 'data-role': dataRole = 'password-strength-indicator', 'data-role-value': dataRoleValue } = props;
    const filled = strength ? STRENGTH_VALUE[strength] : 0;
    const color = strength
        ? STRENGTH_COLOR[strength]
        : INACTIVE_COLOR;
    return (_jsxs(Root, { ref: ref, stack: true, gap: 0.5, className: className, "data-role": dataRole, "data-role-value": dataRoleValue ?? strength, children: [_jsx(FlexBox, { gap: 0.5, vAlign: "center", children: Array.from({ length: SEGMENTS }).map((_, index) => (_jsx(Segment, { "$active": index < filled, "$color": color }, index))) }), strengthLabel ? (_jsx(Typography, { variant: "caption", color: color, children: strengthLabel })) : null, issues && issues.length > 0 && (_jsx(IssueList, { component: "ul", stack: true, gap: 0.25, "data-role": "password-strength-issues", children: issues.map((issue) => (_jsx(Typography, { component: "li", variant: "caption", color: "error.main", children: issue }, issue))) }))] }));
});
PasswordStrengthIndicatorImpl.displayName =
    'PasswordStrengthIndicator';
export const PasswordStrengthIndicator = withVersion(PasswordStrengthIndicatorImpl, '1.0.0');
